import * as React from "react"
import { cn } from "@/lib/utils"

export interface IconContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content to be displayed inside the container
   */
  children: React.ReactNode;

  /**
   * Basic shape variant
   */
  shape?: 'square' | 'rounded' | 'circle';
}

/**
 * A minimal base component for displaying icon content
 * 
 * This serves as the foundation for the adapted IconContainer
 * in the design system.
 */
const IconContainer = React.forwardRef<HTMLDivElement, IconContainerProps>(
  ({ className, children, shape = 'rounded', ...props }, ref) => {
    const shapeClasses = {
      'square': "",
      'rounded': "premium-radius-md",
      'circle': "premium-radius-full"
    };

    return (
      <div
        ref={ref}
        className={cn(
          "flex items-center justify-center",
          shapeClasses[shape],
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)
IconContainer.displayName = "IconContainer"

export { IconContainer } 
